import React from 'react';
import { LegalPage } from './LegalLayout';

const Conditions = () => <LegalPage pageKey="conditions" />;

export default Conditions;
